// extracted by mini-css-extract-plugin
export default {"featureCell":"FeatureCell_featureCell__C-x-N","featureName":"FeatureCell_featureName__1MVwf","featureDesc":"FeatureCell_featureDesc__qpB-V","title":"FeatureCell_title__XIJ5V"};